import styled, { css } from 'styled-components';
import { useState } from 'react';

import { Caret } from 'shared/icons/Caret';
import { GiftCardsFactsWindow } from 'gift-cards/components/GiftCardsFactsWindow';
import { INITIAL_WINDOW_STATE } from 'gift-cards/enums/constants';
import { t } from 'localization/utils/t';
import { useWindowSize } from 'shared/hooks/useWindowSize';
import { variableFontRegular } from 'styles/theme/text';

const TP = 'giftCards.components.GiftCardsFooterLinksDesktop';

interface IGiftCardsFooterLinksDesktopProps {
  isFooterExpanded?: boolean;
  setIsFooterExpanded?: (val: boolean) => void;
}

const WINDOW_POSITION_OFFSET = 390;

export const GiftCardsFooterLinksDesktop = ({
  isFooterExpanded,
  setIsFooterExpanded,
}: IGiftCardsFooterLinksDesktopProps) => {
  const [window, setWindow] = useState(INITIAL_WINDOW_STATE);
  const {
    windowSize: { width },
  } = useWindowSize();

  const handleClick = () => {
    setWindow({ isOpen: true, isPermanent: true });
  };

  const handleClose = () => {
    setWindow(INITIAL_WINDOW_STATE);
  };

  const handleMouseEnter = () => {
    setWindow({ ...window, isOpen: true });
  };

  const handleMouseLeave = () => {
    if (!window.isPermanent) {
      setWindow({ ...window, isOpen: false });
    }
  };

  return (
    <GiftCardsFooterLinksDesktop.Wrapper $isOpen={window.isOpen}>
      <button
        type="button"
        data-qa="gift_cards_facts"
        className="giftCardFacts"
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onTouchStart={handleMouseEnter}
      >
        {t(`${TP}.facts`, 'Facts')}
      </button>
      {window.isOpen && (
        <GiftCardsFactsWindow
          isPermanent={window.isPermanent}
          handleClick={handleClick}
          handleClose={handleClose}
          initialWindowPosition={{ bottom: 200, left: width - WINDOW_POSITION_OFFSET }}
        />
      )}

      <GiftCardsFooterLinksDesktop.ExpandFooterCaret
        onClick={() => setIsFooterExpanded(!isFooterExpanded)}
      >
        <Caret direction={isFooterExpanded ? 'down' : 'up'} />
      </GiftCardsFooterLinksDesktop.ExpandFooterCaret>
    </GiftCardsFooterLinksDesktop.Wrapper>
  );
};

GiftCardsFooterLinksDesktop.Wrapper = styled.div<{ $isOpen: boolean }>`
  align-items: flex-start;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: flex-end;
  z-index: ${({ theme }) => theme.zIndex.pdpFooterItem};
  flex: 1;

  .giftCardFacts {
    padding-top: 15px;
    padding-right: 20px;
    ${variableFontRegular({ size: '11.5px', height: '14px' })};

    ${({ $isOpen }) =>
      $isOpen &&
      css`
        text-decoration: underline;
      `}

    :hover {
      text-decoration: underline;
    }
  }
`;

GiftCardsFooterLinksDesktop.ExpandFooterCaret = styled.div`
  cursor: pointer;
  padding-top: 13px;
  padding-right: 16px;
  width: 51px;
  z-index: ${({ theme }) => theme.zIndex.snackbarNotification};
`;
